/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var switchToPrint = require('common/util/switchToPrint');
var SideNavSectionView = require('common/views/SideNavSectionView');

var ConsumerDiscountAnnualReportGeneralDetailsSectionView = require('./ConsumerDiscountAnnualReportGeneralDetailsSectionView');
var ConsumerDiscountAnnualReportFinancialStatementsSectionView = require('./ConsumerDiscountAnnualReportFinancialStatementsSectionView');
var ConsumerDiscountAnnualReportProductionReportSectionView = require('./ConsumerDiscountAnnualReportProductionReportSectionView');
var ConsumerDiscountAnnualReportAffirmationSectionView = require('./ConsumerDiscountAnnualReportAffirmationSectionView');

var SubmitConsumerDiscountAnnualReport = require('../../services/SubmitConsumerDiscountAnnualReport');

var tmplConsumerDiscountAnnualReportView = require('./ConsumerDiscountAnnualReportView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConsumerDiscountAnnualReportView,

  className: 'consumer-discount-annual-report-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    consumerDiscountAnnualReportContainer: '.consumer-discount-annual-report-container'
  },

  regions: {
    consumerDiscountAnnualReportContainer: '@ui.consumerDiscountAnnualReportContainer'
  },

  onBeforeShow: function() {
    var mode = this.options.mode;
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'consumerDiscountAnnualReportGeneralDetails',
          title: 'General Details',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new ConsumerDiscountAnnualReportGeneralDetailsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'consumerDiscountAnnualReportFinancialStatements',
          title: 'Financial Statements',
          view: new ConsumerDiscountAnnualReportFinancialStatementsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'consumerDiscountAnnualReportProductionReport',
          title: 'Production Report',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new ConsumerDiscountAnnualReportProductionReportSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'consumerDiscountAnnualReportAffirmation',
          title: 'Affirmation',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new ConsumerDiscountAnnualReportAffirmationSectionView({
            isReadOnly: this.options.isReadOnly,
            mode: this.options.mode,
            model: this.model
          })
        }
      ]),
      useNavigationButtons: !this.options.isReadOnly,
      expanded: isForPrinting || isExpandInternal,
      contentWidth: 'medium',
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        }
      ]
    });

    if (
      this.options.isReadOnly &&
      !(this.options.mode === 'print' || this.options.mode === 'int' || this.options.mode === 'int-expand')
    ) {
      this.form.collection.remove(this.form.collection.get('consumerDiscountAnnualReportAffirmation'));
    }

    this.showChildView('consumerDiscountAnnualReportContainer', this.form);
  },

  onClickSave: function(e) {
    e.preventDefault();
    var self = this;
    self.form.validateAll({ type: 'save' }).done(function() {
      var l = Ladda.create(e.currentTarget);
      l.start();

      var rawFormData = self.form.getFormData();
      var formData = {
        applicationId: self.model.get('applicationId'),
        annualReportId: self.model.get('annualReportId'),
        generalDetails: rawFormData.consumerDiscountAnnualReportGeneralDetails,
        financialStatements: rawFormData.consumerDiscountAnnualReportFinancialStatements,
        productionReport: rawFormData.consumerDiscountAnnualReportProductionReport,
        affirmation: rawFormData.consumerDiscountAnnualReportAffirmation
      };

      SubmitConsumerDiscountAnnualReport(formData)
        .done(function() {
          l.stop();
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      switchToPrint(this.$el, '.input-view');
    }
  }
});
